import { useMutation } from "react-query";
import UploadSKU from "@funded-here-interface/investor-onboarding/src/services/uploadSku";
function useUploadSku() {
  return useMutation(["UploadSKU"], UploadSKU);
}

export default useUploadSku;
